import { render, staticRenderFns } from "./StartRisk.vue?vue&type=template&id=2ce23040&scoped=true"
import script from "./StartRisk.vue?vue&type=script&lang=js"
export * from "./StartRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce23040",
  null
  
)

export default component.exports